import { UserButton } from '@stackframe/react';
import { Menu, Wifi, WifiOff, X } from 'lucide-react';
import { ThemeToggle } from './ThemeToggle.tsx';

interface Props {
  title: string;
  liveConnected: boolean;
  navOpen?: boolean;
  onMenuToggle?: () => void;
}

export function TopBar({ title, liveConnected, navOpen, onMenuToggle }: Props) {
  return (
    <header className="topbar">
      <button
        className="nav-toggle"
        onClick={onMenuToggle}
        aria-label={navOpen ? 'Close navigation' : 'Open navigation'}
        aria-expanded={navOpen}
      >
        {navOpen ? <X size={18} /> : <Menu size={18} />}
      </button>
      <h1>{title}</h1>
      <div className="spacer" />
      <span className={`live-pill ${liveConnected ? 'live' : 'dead'}`}>
        {liveConnected ? <Wifi size={12} /> : <WifiOff size={12} />}
        {liveConnected ? 'live' : 'offline'}
      </span>
      <ThemeToggle />
      <UserButton />
    </header>
  );
}
